import { buttonVariants, cn } from "@devhop/ui";
import { RiExternalLinkLine } from "@remixicon/react";
import { Link } from "@tanstack/react-router";

const destinations = [
  ["products", "ຈັດການສິນຄ້າ / OBS"],
  ["customers", "ລູກຄ້າ"],
  ["paid", "ຍອດຂາຍຈິງ"],
  ["sales", "CF ທັງໝົດ"],
  ["comments", "ຄອມເມັນທັງໝົດ"],
  ["guide", "ວິທີຄອມເມັນ"],
] as const;

export function FeedWorkspaceNavigation({
  feedId,
  activeTab,
}: {
  feedId: string;
  activeTab: string;
}) {
  return (
    <nav
      aria-label="ຈັດການ Live / Feed"
      className="flex flex-wrap gap-1 border-b pb-3"
    >
      {destinations.map(([tab, label]) => {
        const active =
          activeTab === tab || (tab === "products" && activeTab === "monitor");
        return (
          <Link
            key={tab}
            to="/app/feeds/$id"
            params={{ id: feedId }}
            search={{ tab }}
            aria-current={active ? "page" : undefined}
            className={cn(
              buttonVariants({ variant: active ? "secondary" : "ghost" }),
              "min-h-11",
            )}
          >
            {label}
          </Link>
        );
      })}
      <a
        href={`/app/feeds/${encodeURIComponent(feedId)}/monitor-display`}
        target="_blank"
        rel="noreferrer"
        className={cn(buttonVariants({ variant: "outline" }), "min-h-11")}
      >
        <RiExternalLinkLine size={18} />
        ເປີດໜ້າຈໍ
      </a>
    </nav>
  );
}
